<div class="response-dialog">
  <button type="button" class="response-dialog-close" (click)="activeModal.dismiss()" aria-label="Fermer">
    <i class="ph ph-x"></i>
  </button>

  <div class="response-dialog-header">
    @if (!isLibraryDeleteConfirm) {
      <div
        class="response-dialog-icon"
        [class.response-dialog-icon--error]="config.iconModifier === 'error'"
        [class.response-dialog-icon--frozen]="config.iconModifier === 'frozen'"
      >
        <i class="ph {{ config.icon }}"></i>
      </div>
    }
    <h2 class="response-dialog-title">{{ config.titleKey | translate: titleParams }}</h2>
  </div>

  @if (isConfirmMode) {
    @if (isLibraryDeleteConfirm) {
      <p class="response-dialog-body" [class.response-dialog-body--sm]="projects.length > 0">
        @if (!projects.length) {
          {{ 'tenders.library.delete-modal.body-unused' | translate: { name: documentName } }}
        } @else if (projects.length === 1) {
          {{ 'tenders.library.delete-modal.body-used-one' | translate: { name: documentName } }}
        } @else {
          {{ 'tenders.library.delete-modal.body-used-many' | translate: { name: documentName, count: projects.length } }}
        }
      </p>
      @if (projects.length) {
        <div class="response-dialog-project-pills">
          @for (project of projects; track project.id) {
            <a
              class="response-dialog-project-pill"
              [class.response-dialog-project-pill--closed]="project.is_active === false"
              [href]="'/tenders/responses/' + project.id"
              target="_blank"
              rel="noopener noreferrer"
              [attr.title]="
                project.is_active === false
                  ? ('tenders.library.delete-modal.project-closed' | translate)
                  : ('tenders.library.delete-modal.open-project' | translate)
              "
            >
              <span class="response-dialog-project-pill__dot" aria-hidden="true"></span>
              <span class="response-dialog-project-pill__name">{{ project.name }}</span>
              <i class="ph ph-arrow-square-out response-dialog-project-pill__icon" aria-hidden="true"></i>
            </a>
          }
        </div>
      }
      <div class="response-dialog-footer" [class.response-dialog-footer--spaced]="!projects.length">
        <button type="button" class="response-dialog-dismiss" (click)="activeModal.dismiss()">
          {{ 'tenders.library.delete-modal.cancel' | translate }}
        </button>
        <button type="button" class="response-dialog-btn-danger" (click)="confirm()">
          {{ 'tenders.library.delete-modal.confirm' | translate }}
        </button>
      </div>
    } @else {
      <p class="response-dialog-body response-dialog-body--sm">
        {{ 'tenders.responses.delete-project-modal.intro' | translate }}
      </p>
      <p class="response-dialog-name">"{{ projectName }}"</p>
      <div class="response-dialog-encart response-dialog-encart--danger">
        <p class="response-dialog-encart-text">
          {{ 'tenders.responses.delete-project-modal.warning' | translate }}
        </p>
      </div>
      <div class="response-dialog-footer">
        <button type="button" class="response-dialog-dismiss" (click)="activeModal.dismiss()">
          {{ 'tenders.responses.delete-project-modal.cancel' | translate }}
        </button>
        <button type="button" class="response-dialog-btn-danger" (click)="confirm()">
          {{ 'tenders.responses.delete-project-modal.confirm' | translate }}
        </button>
      </div>
    }
  } @else {
    <p class="response-dialog-body">{{ config.bodyKey ?? '' | translate: config.bodyParams }}</p>
    @if (config.showCta) {
      <div class="response-dialog-cta-block">
        <p class="response-dialog-cta-text">{{ config.ctaTextKey ?? '' | translate }}</p>
        <a class="response-dialog-cta-btn" [href]="mailtoHref" target="_blank">
          <i class="ph ph-envelope"></i>
          {{ 'tenders.responses.trial-banner.cta' | translate }}
        </a>
      </div>
    }
    <div class="response-dialog-footer">
      @if (config.reloadOnDismiss) {
        <button type="button" class="response-dialog-primary-btn" (click)="reload()">
          {{ 'tenders.responses.concurrent-modal.reload' | translate }}
        </button>
      } @else if (config.primaryDismiss) {
        <button type="button" class="response-dialog-primary-btn" (click)="activeModal.dismiss()">
          {{ 'tenders.responses.quota-modal.dismiss' | translate }}
        </button>
      } @else {
        <button type="button" class="response-dialog-dismiss" (click)="activeModal.dismiss()">
          {{ 'tenders.responses.quota-modal.dismiss' | translate }}
        </button>
      }
    </div>
  }
</div>
